// The dedicated affiliate application form has been merged into the unified
// /partners/apply flow. This route now redirects there, pre-selecting the
// Affiliate layer so the applicant lands on the right defaults.
import { Navigate, useLocation } from "react-router-dom";

const AffiliateApply = () => {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const existing = search.get("roles");
  const roles = existing
    ? Array.from(new Set([...existing.split(","), "affiliate"])).join(",")
    : "affiliate";
  search.set("roles", roles);
  return <Navigate to={`/partners/apply?${search.toString()}`} replace />;
};

export default AffiliateApply;
